import React from 'react';

import { SearchBarProps } from './types';

const Context = React.createContext<SearchBarProps>({
  initialValue: '',
  initialSuggestions: [],
});

Context.displayName = 'SearchBarContext';

export const SearchBarProvider = Context.Provider;

export const useSearchBarContext = () => React.useContext(Context);
